import { Instance, flow, types } from 'mobx-state-tree';

import { createStudentFinalCertificate } from '@common/api/reports';
import academicStartImg from '@common/assets/images/certificates/academic-start.png';
import foundationImg from '@common/assets/images/certificates/foundation.png';
import ieltsForIscImg from '@common/assets/images/certificates/ielts-for-isc.png';
import internationalSchoolAdvancedImg from '@common/assets/images/certificates/international-school-advanced.png';
import internationalSchoolImg from '@common/assets/images/certificates/international-school.png';
import preFoundationImg from '@common/assets/images/certificates/pre-foundation.png';
import smartTeensImg from '@common/assets/images/certificates/smart-teens.png';
import starKidsImg from '@common/assets/images/certificates/star-kids.png';

const IMAGES: Record<string, string> = {
	foundation: foundationImg,
	'pre-foundation': preFoundationImg,
	'international-school': internationalSchoolImg,
	'international-school-advanced': internationalSchoolAdvancedImg,
	'star-kids': starKidsImg,
	'smart-teens': smartTeensImg,
	'academic-start': academicStartImg,
	'ielts-for-isc': ieltsForIscImg,
};

export const AverageModel = types.model('AverageModel', {
	value: types.maybeNull(types.number),
	threshold: types.maybeNull(types.number),
	isPassed: types.maybeNull(types.boolean),
});

export const AverageStatsModel = types.model('AverageStatsModel', {
	overallGrade: types.maybeNull(AverageModel),
	scoreGrade: types.maybeNull(AverageModel),
	finalTestGrade: types.maybeNull(AverageModel),
	homeworkPercent: types.maybeNull(AverageModel),
});

export const StatisticsModel = types.model('StatisticsModel', {
	averageStats: types.maybeNull(AverageStatsModel),
	certifacatesAvailability: types.maybeNull(
		types.model({
			achievement: types.maybeNull(types.boolean),
			completion: types.maybeNull(types.boolean),
		}),
	),

	programsStats: types.maybeNull(types.frozen()),
	id: types.maybeNull(types.number),
	name: types.maybeNull(types.string),
});

const Certificate = types
	.model('Certificate', {
		product: types.optional(types.string, ''),
		name: types.optional(types.string, ''),
		certificateLevel: types.maybeNull(types.optional(types.string, '')),
		statistics: types.maybeNull(StatisticsModel),
		pdfUrl: types.maybeNull(types.optional(types.string, '')),
		pngUrl: types.maybeNull(types.optional(types.string, '')),
		program_id: types.maybeNull(types.number),
	})
	.volatile(() => ({
		loading: false,
		filePdfUrl: '',
		filePngUrl: '',
	}))
	.views((self) => ({
		get isAchievement() {
			return self.statistics?.certifacatesAvailability?.achievement;
		},
		get imgUrl() {
			return IMAGES[self.product];
		},
	}))
	.actions((self) => ({
		createStudentFinalCertificate: flow(function* (student_id: number) {
			const result = yield createStudentFinalCertificate({
				student_id,
				product: self.product,
				program_id: self?.program_id ?? undefined,
			});

			self.filePdfUrl = result?.[0]?.pdf_url;
			self.filePngUrl = result?.[0]?.png_url;
		}),
	}));

export default Certificate;

export interface ICertificateModel extends Instance<typeof Certificate> {}
